import React from "react";
import { Link } from "react-router-dom";

const ButtonGroup = ({ showSearchModal }) => {
  return (
    <div style={{ paddingBottom: 10 }}>
      <div className="btn-group">
        <Link to="/manage" className="btn btn-primary">
          <i className="fa fa-plus-circle" /> Add Exhibit
        </Link>
        <button className="btn btn-warning" onClick={showSearchModal}>
          <i className="fa fa-search" /> Search Exhibits
        </button>
      </div>
    </div>
  );
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/pages/Exhibits/ButtonGroup.jsx